import * as _terser2 from "terser";

var _terser = "default" in _terser2 ? _terser2.default : _terser2;

var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var terser$1 = _terser;

function terser(options) {
  return {
    name: "terser",

    async renderChunk(code, chunk, outputOptions) {
      const defaultOptions = {
        sourceMap: outputOptions.sourcemap === true || typeof outputOptions.sourcemap === "string"
      };

      if (outputOptions.format === "es") {
        defaultOptions.module = true;
      }

      if (outputOptions.format === "cjs") {
        defaultOptions.toplevel = true;
      }

      return terser$1.minify(code, { ...defaultOptions,
        ...(options || {})
      });
    }

  };
}

exports.default = terser;
exports = Object.assign(exports.default, exports); //# sourceMappingURL=index.js.map

export default exports;
export const __esModule = exports.__esModule;